// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-Uvv","type":"styles_type__UGDu9","choices":"styles_choices__1IA8P"};